import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axiosInstance from "../../../services/AxiosInstance";
import Api from "../../../constants/Api";
import { successAlert } from "../alert/defaultAlert";
import InputDecimal from "../Forms/Element/InputDecimal";
import HintTooltip from "../Common/HintTooltip";
import CustomSelect from "../Forms/Element/CustomSelect";

const GamificationSetting = () => {

    const { t } = useTranslation();
    const [potCommission, setPotCommission] = useState(0.0);
    const [allowPotValueAdjustment, setAllowPotValueAdjustment] = useState(true);
    const adjustmentOptions = [
        { value: true, label: t('yes') },
        { value: false, label: t('no') }
    ];

    const save = () => {
        let data = {
            potCommission: potCommission,
            allowPotValueAdjustment
        }

        axiosInstance.post(Api.parameter.gamification, data).then(() => successAlert(t('message.data_updated_successfully'), null));
    }

    useEffect(() => {
        axiosInstance.get(Api.parameter.gamification)
            .then((resp) => {
                if (resp.data.length > 0) {
                    let data = resp.data[0];
                    setPotCommission(data.potCommission);
                    setAllowPotValueAdjustment(data.allowPotValueAdjustment !== false);
                }
            });
    }, []);

    return (
        <div className="card">
            <div className="card-body">
                <h3 className="mb-2">{t('gamification.label')}</h3>
                <p className="text-muted small mb-4">Configure o percentual destinado ao pote de premiação, que será distribuído entre os colaboradores conforme a pontuação de cada um.</p>
                <hr className="my-4" />
                <div className="row">
                    <div className="col-md-4">
                        <div className="setting-input">
                            <label className="form-label">{t('gamification.pot_commission')}(%) <HintTooltip text={t('gamification.message.pot_commission_config_hint')} /></label>
                            <InputDecimal
                                name="potCommission"
                                // Guarda o número, não o texto da tela: "25,93" enviado como string é
                                // recusado pela API, que espera um Double.
                                onValueChange={(values) => setPotCommission(values.floatValue ?? 0)}
                            value={potCommission} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="setting-input">
                            <label className="form-label mb-0 me-2">
                                Permitir ajuste manual do valor do pote{' '}
                                <HintTooltip text="Permite corrigir manualmente o valor calculado do pote para um período específico. Use somente quando houver uma revisão ou ajuste previamente definido; essa alteração não modifica as vendas ou assinaturas registradas." />
                            </label>
                            <CustomSelect
                                value={adjustmentOptions.find((option) => option.value === allowPotValueAdjustment)}
                                options={adjustmentOptions}
                                onChange={(option) => setAllowPotValueAdjustment(option?.value !== false)}
                                isClearable={false}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <Link to={"#"} className="btn btn-primary btn-md" onClick={() => save()}>{t('save_setting')}</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GamificationSetting;
